/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 */

export const createError = (msg?: string) => {
  const error = new Error(msg)
  try {
    // remove definitelyError and createError from the stack trace
    const stack = error?.stack?.split('\n')
    stack?.splice(1, 2)
    error.stack = stack?.join('\n')
  } catch {}
  return error
}

export const definitelyError = (msg?: string | unknown, e?: Error | unknown) => {
  if (e instanceof Error) {
    return e
  }
  let message: string
  if (typeof msg === 'string') {
    message = msg
  } else {
    message = 'no message passed to definitelyError'
  }
  if (!e) {
    return createError(message)
  }
  let reason: unknown
  if (typeof e === 'object') {
    if ('reason' in e && e.reason) {
      reason = e.reason
    } else if (
      'data' in e &&
      typeof e.data === 'object' &&
      e.data &&
      'reason' in e.data &&
      e.data.reason
    ) {
      reason = e.data?.reason
    } else if ('statusText' in e && e.statusText) {
      reason = e.statusText
    }
  }
  if (typeof reason === 'string') {
    return createError(`${message}: ${reason}`)
  }
  return createError(message)
}
